/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Three_SecondsInputs */

const en_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 3 Second`)
};

const fr_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer de 3 secondes`)
};

const de_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückwärts 3 Sekunden`)
};

const it_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro di 3 secondi`)
};

const ru_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реверс 3 секунды`)
};

const es_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceso de 3 segundos`)
};

const zh_cn2_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒退 3 秒`)
};

const ja_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リバース3秒`)
};

const hi_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवर्स 3 सेकंड`)
};

const pt_pt2_shortcut_keys_name_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverso 3 segundos`)
};

/**
* | output |
* | --- |
* | "Reverse 3 Second" |
*
* @param {Shortcut_Keys_Name_Reverse_Three_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_three_seconds = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Three_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Three_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "de") return de_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "it") return it_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "es") return es_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_reverse_three_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_reverse_three_seconds(inputs)
	return en_shortcut_keys_name_reverse_three_seconds(inputs)
});